export const INVOICING_DIAGNOSTIC_DATE = 'invoicing_diagnostic_date';
export const ENROLLMENT_SELECTIONS_REPORT_GROUP_ID =
  'enrollment_selections_report_group_id';
export const ENROLLMENT_SELECTIONS_REPORT_PLAN_STATUS =
  'enrollment_selections_report_plan_id';
export const DATE_FORMAT = 'DD-MM-YYYY';
